















































































































import { Vue, Component } from 'vue-property-decorator';
import PagingUnit from '@/components/paging/paging.vue';
import CollapseTransition from '@/components/collapseTransition/collapseTransition.ts';
import { userManagementServe } from '@/api/installServer';
import Add from '@/views/system/settings/userManagement/unit/add.vue';
import ResultPwd from '@/views/system/settings/userManagement/unit/resultPwd.vue';
import { TableStripe } from '@/mixins/tableStripe';

@Component({
  components: { ResultPwd, Add, PagingUnit, CollapseTransition },
  mixins: [TableStripe],
})
export default class UserManagement extends Vue {
  private queryDataForm: any = {
    pageNo: 1,
    pageSize: 10,
  };

  private formData: any = {
    admin: false,
    email: '',
    mobile: '',
    id: '',
    nickname: '',
    password: '',
    username: '',
  };
  private loading: any = false; // 表格加载
  private searchFlag = false; // 控制显示查询和隐藏查询
  total = 0; // 数据总共多少条
  private editRoleFlag: any = 1; // 控制显示 编辑 页面
  private row: any = {}; // 控制显示 编辑 页面
  // 搜索栏的数据对象
  private searchFormData: any = {
    search: '', // 搜索名称
  };

  // 表格的数据对象
  tableData: any = [];

  /**
   * @desc Vue 初始化
   * @param1 暂无
   * @returns 暂无
   */
  created() {
    this.getUserListData();
  }

  /**
   * @desc 分页获取所有数据
   * @param1 暂无
   * @returns 暂无
   */
  getUserListData() {
    this.loading = true;
    // 发起接口请求，获取分页数据
    userManagementServe
      .sysAllUserList({
        current: this.queryDataForm.pageNo,
        size: this.queryDataForm.pageSize,
        search: this.searchFormData.search ? this.searchFormData.search : null,
      })
      .then((res: any) => {
        this.tableData = res.data.records;
        this.total = res.data.total;
        this.loading = false;
      })
      .catch((error: any) => {
        this.loading = false;
        this.$message.error('获取数据失败');
      });
  }

  /**
   * @todo 后期需要优化的部分
   * @desc 点击隐藏或查询按钮会触发事件，用于显示和隐藏搜索栏
   * @param1 暂无
   * @returns 暂无
   */
  private hideSearch() {
    this.searchFlag = !this.searchFlag;
  }

  /**
   * @todo 后期需要优化的部分
   * @desc 查询事件
   * @param1 暂无
   * @returns 暂无
   */
  private menuSearch() {
    this.queryDataForm.pageNo = 1;
    this.getUserListData();
  }

  /**
   * @desc 点击分页按钮触发，改变内容
   * 分页回调事件
   * @param1 暂无
   * @returns 暂无
   */
  getListData() {
    // 调用获取分页数据
    this.getUserListData();
  }

  /**
   * @todo 后期需要优化的部分
   * @desc 重置搜索的表单
   * @param1 暂无
   * @returns 暂无
   */
  private resetSearch() {
    this.searchFormData.username = '';
    this.queryDataForm.pageNo = 1;
    this.queryDataForm.pageSize = 10;
    this.getUserListData();
  }

  /**
   * @todo 后期需要优化的部分
   * @desc 新增，编辑按钮点击跳转。
   * @param1 暂无
   * @returns 暂无
   */
  private addAndEditMenu(data: any) {
    this.row = data; // 将该行 id 传递到编辑页面
    this.editRoleFlag = 2; // 进入编辑页面
  }

  /**
   * @todo 后期需要优化的部分
   * @desc 新增，编辑按钮点击跳转。
   * @param1 暂无
   * @returns 暂无
   */
  private resultPassword(data: any) {
    this.row = data; // 将该行 id 传递到编辑页面
    this.editRoleFlag = 3; // 进入编辑页面
  }

  /**
   * @todo 后期需要优化的部分
   * @desc  删除数据
   * @param1 暂无
   * @returns 暂无
   */
  private deleteUser(id: any) {
    this.$confirm('确认要删除该用户吗？', '信息', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
      customClass: 'box--msg',
    })
      .then(() => {
        userManagementServe
          .deleteUserData(id)
          .then((res: any) => {
            this.getUserListData(); // 重新渲染表格数据
            this.$message.success('删除成功!');
          })
          .catch((error: any) => {
            this.$message.error('删除失败,请稍后重试!');
          });
      })
      .catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除！',
        });
      });
  }

  private handleMenuEditResponse() {
    this.editRoleFlag = 1;
    this.getUserListData();
  }

  private handleResultPwdResponse() {
    this.editRoleFlag = 1;
    this.getUserListData();
  }
}
